var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.pnpm/@angular-devkit+build-angular@22.1.8_f56c2610af87467463b65cfdac409ff7/node_modules/@angular-devkit/build-angular/src/tools/babel/webpack-loader.js??ruleSet[1].rules[2].use[0]!./node_modules/.pnpm/source-map-loader@5.0.0_webpack@5.109.2_@swc+core@1.16.2_@swc+helpers@0.5.23__esbuild@0_99bec9b253607ab6d0501c2d8f446144/node_modules/source-map-loader/dist/cjs.js??ruleSet[1].rules[3]!./node_modules/.federation/entry.92cf6555d249bea29f67e746ef42132a.js */ 28633);
	}
	if (typeof prevStartup === 'function') {
	  return prevStartup();
	} else {
	  console.warn('[Module Federation] prevStartup is not a function, skipping startup execution');
	}
};